import React from 'react';
import PropTypes from 'prop-types';
import { useLabelContext } from '../../../../shared/hooks/labelContext';
import { getFormattedValue } from '../../../dashboardUtils';
import { timeSeriesXAxis } from '../../../../shared/constants/constants';

function getDataValue(dataValue, hiddenValue, thresholdValue) {
    return hiddenValue < thresholdValue
        ? hiddenValue
        : dataValue + thresholdValue;
}

// eslint-disable-next-line complexity
export default function PositiveNegativeBarGraphTooltip({
    axisFormatter,
    axisKey,
    dataFormat,
    dataFormatter,
    metricValueKey,
    payload,
    suffix,
    thresholdValue,
    tooltipLabel,
}) {
    const { dashboardLabels } = useLabelContext();

    const dataPayload = payload.find((x) => x.dataKey === axisKey);
    const hiddenPayload = payload.find((x) => x.dataKey === 'hidden');

    if (!dataPayload || !hiddenPayload) {
        return null;
    }

    const dataValue = getDataValue(
        dataPayload.value,
        hiddenPayload.value,
        thresholdValue
    );

    const formattedValue = getFormattedValue(
        dataValue,
        suffix,
        dataFormatter,
        dataFormat
    );

    const capacityValue = getFormattedValue(
        thresholdValue,
        suffix,
        dataFormatter,
        dataFormat
    );

    const header = axisFormatter(dataPayload.payload[timeSeriesXAxis]);

    return (
        <div className="custom-tooltip">
            <div>{header}</div>
            <div>{`${metricValueKey}: ${formattedValue}`}</div>
            <div>{`${
                tooltipLabel ?? dashboardLabels.capacity
            }: ${capacityValue}`}</div>
        </div>
    );
}

PositiveNegativeBarGraphTooltip.propTypes = {
    axisFormatter: PropTypes.func,
    axisKey: PropTypes.string.isRequired,
    dataFormat: PropTypes.string,
    dataFormatter: PropTypes.func,
    metricValueKey: PropTypes.string.isRequired,
    payload: PropTypes.instanceOf(Array),
    suffix: PropTypes.string,
    thresholdValue: PropTypes.number.isRequired,
    tooltipLabel: PropTypes.string,
};

PositiveNegativeBarGraphTooltip.defaultProps = {
    axisFormatter: (value) => value,
    dataFormat: null,
    dataFormatter: null,
    payload: [],
    suffix: '',
};
